(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function isPlainClick(event) {
      return (
        event.button === 0 &&
        !event.metaKey &&
        !event.ctrlKey &&
        !event.shiftKey &&
        !event.altKey
      );
    }

    function announce(cart, source) {
      if (typeof CustomEvent !== 'function') return;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: source } }));
    }

    function setup(drawer) {
      if (drawer.hasAttribute('data-ready')) return;
      drawer.setAttribute('data-ready', '');

      var panel = drawer.querySelector('[data-cart-drawer-panel]');
      var sectionId = drawer.getAttribute('data-section-id');
      var changeUrl = drawer.getAttribute('data-change-url') || '/cart/change';
      var limitedText = drawer.getAttribute('data-limited-text') || '';
      var errorText = drawer.getAttribute('data-error-text') || '';
      var notice = drawer.querySelector('[data-cart-drawer-notice]');
      var noticeTimer = null;
      var closing = false;
      var pending = false;
      var opener = null;
      var timers = [];

      /* Open and close ------------------------------------------------ */

      function open(trigger) {
        if (drawer.open) return;
        opener = trigger || null;
        closing = false;
        drawer.removeAttribute('data-closing');
        if (typeof drawer.showModal === 'function') {
          drawer.showModal();
        } else {
          drawer.setAttribute('open', '');
        }

        /* Started one forced style flush after the dialog is rendered, so
           the slide reliably plays from its first frame. */
        if (!reduceMotion.matches && panel) {
          void drawer.offsetWidth;
          drawer.setAttribute('data-entering', '');

          var done = false;
          function entered() {
            if (done) return;
            done = true;
            panel.removeEventListener('animationend', entered);
            drawer.removeAttribute('data-entering');
          }

          panel.addEventListener('animationend', entered);
          timers.push(setTimeout(entered, 350));
        }
      }

      function finishClose() {
        drawer.removeAttribute('data-entering');
        drawer.removeAttribute('data-closing');
        closing = false;
        if (typeof drawer.close === 'function') {
          drawer.close();
        } else {
          drawer.removeAttribute('open');
        }
        if (opener && typeof opener.focus === 'function') opener.focus();
        opener = null;
      }

      /* The native close is immediate, so the exit animation runs first
         and the dialog is only really closed once the panel has left.
         A timer covers the animation being dropped or disabled. */
      function close() {
        if (!drawer.open || closing) return;
        if (reduceMotion.matches || !panel) {
          finishClose();
          return;
        }

        closing = true;
        /* If the visitor closes mid-entrance, the closing animation takes
           over cleanly rather than fighting the entrance. */
        drawer.removeAttribute('data-entering');
        drawer.setAttribute('data-closing', '');

        var done = false;
        function end() {
          if (done) return;
          done = true;
          panel.removeEventListener('animationend', end);
          finishClose();
        }

        panel.addEventListener('animationend', end);
        timers.push(setTimeout(end, 300));
      }

      /* Contents ------------------------------------------------------- */

      function setBusy(on) {
        if (on) {
          drawer.setAttribute('aria-busy', 'true');
        } else {
          drawer.removeAttribute('aria-busy');
        }
      }

      /* Shows a line of feedback for a few seconds; an empty text clears it. */
      function notify(text) {
        if (!notice) return;
        if (noticeTimer) clearTimeout(noticeTimer);
        notice.textContent = text || '';
        notice.hidden = !text;
        if (!text) return;
        noticeTimer = setTimeout(function () {
          notice.hidden = true;
        }, 4000);
        timers.push(noticeTimer);
      }

      /* Fetches this section freshly rendered and swaps the inside of the
         panel, leaving the dialog itself (and its open state) untouched. */
      function refresh() {
        setBusy(true);
        return fetch(rootUrl + '?sections=' + encodeURIComponent(sectionId), {
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart-drawer render failed');
            return response.json();
          })
          .then(function (sections) {
            var html = sections[sectionId];
            if (!html) return;

            var fresh = new DOMParser().parseFromString(html, 'text/html');
            var freshContent = fresh.querySelector('[data-cart-drawer-content]');
            var freshCount = fresh.querySelector('[data-cart-drawer-count]');
            var content = drawer.querySelector('[data-cart-drawer-content]');
            var count = drawer.querySelector('[data-cart-drawer-count]');

            if (freshContent && content) content.innerHTML = freshContent.innerHTML;
            if (freshCount && count) {
              count.textContent = freshCount.textContent;
              count.hidden = freshCount.hidden;
            }
          })
          .catch(function () {
            /* The panel keeps showing what it had; the next change tries again. */
          })
          .then(function () {
            setBusy(false);
          });
      }

      function updateCounters(cart) {
        var counters = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < counters.length; i++) {
          counters[i].textContent = cart.item_count;
          counters[i].hidden = cart.item_count === 0;
        }
      }

      function change(line, quantity) {
        if (pending) return;
        pending = true;
        setBusy(true);
        notify('');

        var requested = parseInt(quantity, 10);
        var lineIndex = parseInt(line, 10) - 1;

        var body = new URLSearchParams();
        body.set('line', line);
        body.set('quantity', quantity);

        fetch(changeUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          body: body.toString()
        })
          .then(function (response) {
            if (response.ok) return response.json();
            /* A refusal comes with the store's own explanation, which is
               worth more to the visitor than a generic line. */
            return response.json().then(
              function (error) {
                throw new Error((error && error.description) || errorText);
              },
              function () {
                throw new Error(errorText);
              }
            );
          })
          .then(function (cart) {
            /* The store caps a quantity at what is in stock without saying
               so. The visitor is told here rather than left watching
               nothing happen. */
            var item = cart.items && cart.items[lineIndex];
            if (item && requested > item.quantity) {
              notify(limitedText.replace('__quantity__', item.quantity));
            }

            updateCounters(cart);
            /* Lets the product page refresh its per-variant counts. */
            announce(cart, 'cart-drawer');
            return refresh();
          })
          .catch(function (error) {
            /* Nothing changed server-side, so nothing to undo. */
            notify((error && error.message) || errorText);
          })
          .then(function () {
            pending = false;
            setBusy(false);
          });
      }

      /* Replaces a line with the same quantity of another variant: remove
         then add, and let the re-render tell the truth. If the add fails
         halfway the refresh still shows the real cart, never a guess. */
      function swap(line, variantId, quantity) {
        if (pending) return;
        pending = true;
        setBusy(true);

        var removeBody = new URLSearchParams();
        removeBody.set('line', line);
        removeBody.set('quantity', '0');

        fetch(changeUrl + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          body: removeBody.toString()
        })
          .then(function (response) {
            if (!response.ok) throw new Error('cart-drawer swap failed');

            var addBody = new URLSearchParams();
            addBody.set('id', variantId);
            addBody.set('quantity', quantity);

            return fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json'
              },
              body: addBody.toString()
            });
          })
          .then(function () {
            return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateCounters(cart);
            announce(cart, 'cart-drawer');
          })
          .catch(function () {
            /* The refresh below re-renders whatever really happened. */
          })
          .then(function () {
            return refresh();
          })
          .then(function () {
            pending = false;
            setBusy(false);
          });
      }

      /* Wiring --------------------------------------------------------- */

      /* The header's cart button. Modifier clicks keep their link behaviour
         so the /cart page still opens in a new tab. */
      document.addEventListener('click', function (event) {
        var trigger = event.target.closest ? event.target.closest('[data-cart-open]') : null;
        if (!trigger || !isPlainClick(event)) return;
        event.preventDefault();
        open(trigger);
        refresh();
      });

      drawer.addEventListener('click', function (event) {
        var target = event.target;

        if (target === drawer) {
          close();
          return;
        }

        var closeButton = target.closest('[data-cart-drawer-close]');
        if (closeButton) {
          close();
          return;
        }

        var changeButton = target.closest('[data-cart-change]');
        if (changeButton) {
          change(
            changeButton.getAttribute('data-line'),
            changeButton.getAttribute('data-quantity')
          );
        }
      });

      /* The size dropdowns on the line items. */
      drawer.addEventListener('change', function (event) {
        var select = event.target.closest ? event.target.closest('[data-cart-swap]') : null;
        if (!select) return;
        swap(
          select.getAttribute('data-line'),
          select.value,
          select.getAttribute('data-quantity')
        );
      });

      /* Escape fires `cancel`; it is intercepted so the exit still animates. */
      drawer.addEventListener('cancel', function (event) {
        event.preventDefault();
        close();
      });

      /* Something else (the product page's add button) changed the cart. */
      document.addEventListener('cart:updated', function (event) {
        var detail = event.detail || {};
        if (detail.source === 'cart-drawer') return;
        refresh();
      });

      /* Coming back through history can restore the page mid-close. */
      window.addEventListener('pageshow', function (event) {
        if (event.persisted && drawer.open) finishClose();
      });

      window.addEventListener('pagehide', function () {
        for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
      });

      /* In the theme editor, selecting the section shows the drawer. */
      document.addEventListener('shopify:section:select', function (event) {
        if (event.target && event.target.contains(drawer)) open();
      });

      document.addEventListener('shopify:section:deselect', function (event) {
        if (event.target && event.target.contains(drawer)) close();
      });
    }

    function init() {
      var drawers = document.querySelectorAll('[data-cart-drawer]');
      for (var i = 0; i < drawers.length; i++) setup(drawers[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /* The theme editor re-renders sections in place. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    function setup(login) {
      if (login.hasAttribute('data-ready')) return;
      login.setAttribute('data-ready', '');

      var input = login.querySelector('input[type="password"]');

      /* Opening puts the cursor straight in the field. */
      login.addEventListener('toggle', function () {
        if (login.open && input) input.focus();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && login.open) login.removeAttribute('open');
      });

      document.addEventListener('click', function (event) {
        if (login.open && !login.contains(event.target)) login.removeAttribute('open');
      });
    }

    function init() {
      var logins = document.querySelectorAll('[data-password-login]');
      for (var i = 0; i < logins.length; i++) setup(logins[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function parseJSON(element, fallback) {
      if (!element) return fallback;
      try {
        return JSON.parse(element.textContent);
      } catch (error) {
        return fallback;
      }
    }

    function setup(root) {
      /* Media ---------------------------------------------------------- */

      var slides = root.querySelectorAll('[data-media-slide]');
      var dots = root.querySelectorAll('[data-media-dot]');
      var prev = root.querySelector('[data-media-prev]');
      var next = root.querySelector('[data-media-next]');
      /* The active slide is the first unless the inline script under the
         hero opened the page on the image the grid handed off. */
      var index = 0;
      for (var s = 0; s < slides.length; s++) {
        if (slides[s].hasAttribute('data-active')) index = s;
      }

      /* Arriving from the grid, the hero is held invisible over the cached
         grid rendition (see the stylesheet) and faded in once decoded, so
         a slow download never ends in a hard swap from blurry to sharp. */
      var hero = slides.length ? slides[index].querySelector('.product__image') : null;

      if (hero instanceof HTMLImageElement && document.documentElement.classList.contains('product-handoff')) {
        if (hero.complete) {
          /* Loaded before the script ran, so it was sharp from first paint. */
          hero.setAttribute('data-ready', 'instant');
        } else {
          var reveal = function () {
            hero.setAttribute('data-ready', '');
          };

          if (typeof hero.decode === 'function') {
            hero.decode().then(reveal, reveal);
          } else {
            hero.addEventListener('load', reveal);
            hero.addEventListener('error', reveal);
          }
        }
      }

      /* One change at a time. While the strip is travelling, another tap
         on an arrow, a dot or a swipe is dropped, so hammering a control
         cannot send the images looping past each other. A change asked
         for by picking a variant is kept instead (`queued`), and made once
         the strip has settled, so the variant never ends up out of step
         with its image. */
      var moving = false;
      var pending = null;
      var settle = null;

      /* `direction` is 1 for forward (the new image arrives from the right)
         and -1 for back (from the left). It comes from whichever control was
         used, so the next arrow always brings the image in from the right,
         even when wrapping from the last image round to the first. Dots
         pass nothing and the direction follows the order of the images. */
      function show(target, direction, queued) {
        if (slides.length < 2) return;
        /* Wraps in both directions, so neither arrow is ever a dead end. */
        var next = (target + slides.length) % slides.length;

        if (moving) {
          if (queued) pending = { target: target, direction: direction };
          return;
        }

        if (next === index) return;
        if (!direction) direction = next > index ? 1 : -1;

        var incoming = slides[next];
        var outgoing = slides[index];

        /* Parks the incoming slide on the side it should arrive from, with
           the move there hidden: it may be waiting on the other side from a
           previous change. The reflow commits that position before the
           transition is switched back on. */
        incoming.style.transition = 'none';
        incoming.style.setProperty('--slide-shift', direction);
        void incoming.offsetWidth;
        incoming.style.transition = '';

        outgoing.style.setProperty('--slide-shift', -direction);
        outgoing.removeAttribute('data-active');

        incoming.style.setProperty('--slide-shift', 0);
        incoming.setAttribute('data-active', '');

        index = next;

        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
        }

        /* Released when the incoming slide has finished its travel. A timer
           covers the transition being dropped or disabled (reduced motion
           turns it off, so the duration is read rather than assumed), and
           the lock never outlives the movement. */
        moving = true;

        var done = function (event) {
          if (event && (event.target !== incoming || event.propertyName !== 'transform')) return;
          incoming.removeEventListener('transitionend', done);
          clearTimeout(settle);
          moving = false;

          if (pending !== null) {
            var change = pending;
            pending = null;
            show(change.target, change.direction);
          }
        };

        var duration = parseFloat(getComputedStyle(incoming).transitionDuration) * 1000 || 0;

        incoming.addEventListener('transitionend', done);
        settle = setTimeout(done, duration + 100);
      }

      function showMedia(mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
            show(i, 0, true);
            return;
          }
        }
      }

      if (prev) prev.addEventListener('click', function () { show(index - 1, -1); });
      if (next) next.addEventListener('click', function () { show(index + 1, 1); });

      for (var d = 0; d < dots.length; d++) {
        (function (target) {
          dots[target].addEventListener('click', function () { show(target); });
        })(d);
      }

      /* Swipe, since this layout is mostly looked at on a phone. The first
         few pixels of movement decide what the touch is: mostly sideways
         and the carousel claims it, cancelling the page's scroll for the
         rest of the touch; mostly up or down and it is left to the page,
         and never changes the image. */
      var startX = null;
      var startY = null;
      var axis = null;
      var media = root.querySelector('[data-media]');

      if (media && slides.length > 1) {
        media.addEventListener('touchstart', function (event) {
          if (event.touches.length > 1) {
            startX = null;
            return;
          }
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          axis = null;
        }, { passive: true });

        /* Not passive: Safari only lets a scroll be cancelled before it
           has started, so the decision is made inside the first few
           pixels, below the distance at which the page starts to move. */
        media.addEventListener('touchmove', function (event) {
          if (startX === null) return;
          if (axis === null) {
            var dx = Math.abs(event.touches[0].clientX - startX);
            var dy = Math.abs(event.touches[0].clientY - startY);
            if (dx < 5 && dy < 5) return;
            axis = dx > dy ? 'x' : 'y';
          }
          if (axis === 'x' && event.cancelable) event.preventDefault();
        }, { passive: false });

        media.addEventListener('touchend', function (event) {
          if (startX === null) return;
          var delta = event.changedTouches[0].clientX - startX;
          /* A swipe to the left pulls the next image in from the right. */
          if (axis === 'x' && Math.abs(delta) > 40) show(index + (delta < 0 ? 1 : -1), delta < 0 ? 1 : -1);
          startX = null;
        }, { passive: true });
      }

      /* Zoom ----------------------------------------------------------- */

      var zoom = root.querySelector('[data-zoom]');
      var zoomOpen = root.querySelector('[data-zoom-open]');

      if (zoom && zoomOpen && media) {
        var zoomStage = zoom.querySelector('[data-zoom-stage]');
        var zoomSlides = zoom.querySelectorAll('[data-zoom-slide]');
        var zoomClose = zoom.querySelector('[data-zoom-close]');
        var zoomPrev = zoom.querySelector('[data-zoom-prev]');
        var zoomNext = zoom.querySelector('[data-zoom-next]');
        var zoomCount = zoom.querySelector('[data-zoom-count]');
        var zoomMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var zoomEase = 'cubic-bezier(0.165, 0.84, 0.44, 1)';
        var zoomIndex = 0;
        var zoomImage = null;
        var zoomClosing = false;

        /* Where the image is. A `scale` of 1 fits it to the screen; the pan
           is how far its centre has moved from the centre of the screen.
           Every image arrives zoomed in, ready to be dragged about: less so
           on a desktop, where the image already fits the screen at a much
           larger size than on a phone. The breakpoint is the stylesheet's.
           Pinching and the wheel go anywhere between the whole image and
           MAX_SCALE, past which the 2400px rendition starts to soften on
           most screens. */
        var scale = 1;
        var panX = 0;
        var panY = 0;
        var ZOOM_SCALE = 2.5;
        var ZOOM_SCALE_DESKTOP = 1.75;
        var MAX_SCALE = 4;
        var zoomDesktop = window.matchMedia('(min-width: 750px)');

        function paint() {
          if (!zoomImage) return;
          zoomImage.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
          if (scale > 1) {
            zoom.setAttribute('data-zoomed', '');
          } else {
            zoom.removeAttribute('data-zoomed');
          }
        }

        /* Larger than the screen, the image may move only as far as keeps
           it covering the screen; smaller, it stays centred. */
        function clamp() {
          var limitX = Math.max(0, (zoomImage.offsetWidth * scale - zoomStage.clientWidth) / 2);
          var limitY = Math.max(0, (zoomImage.offsetHeight * scale - zoomStage.clientHeight) / 2);
          panX = Math.min(limitX, Math.max(-limitX, panX));
          panY = Math.min(limitY, Math.max(-limitY, panY));
        }

        /* A point on screen, measured from the image's resting centre. */
        function fromCentre(x, y) {
          var box = zoomStage.getBoundingClientRect();
          return { x: x - box.left - box.width / 2, y: y - box.top - box.height / 2 };
        }

        /* Scales about a point, so whatever is under the cursor or the
           finger stays under it. */
        function zoomAt(next, point) {
          next = Math.min(MAX_SCALE, Math.max(1, next));
          panX = point.x - (point.x - panX) * (next / scale);
          panY = point.y - (point.y - panY) * (next / scale);
          scale = next;
          clamp();
          paint();
        }

        function reset() {
          scale = 1;
          panX = 0;
          panY = 0;
          paint();
        }

        /* Sets the image down without easing it there, for an image that
           arrives and should not be seen travelling from wherever it was
           last left. The forced layout commits the position while the
           transition is off. */
        function place() {
          zoom.setAttribute('data-gesture', '');
          paint();
          void zoomImage.offsetWidth;
          zoom.removeAttribute('data-gesture');
        }

        function dropStandIn(event) {
          event.currentTarget.style.backgroundImage = '';
        }

        /* Until the large rendition has arrived, the hero's own, already in
           the cache, stands in behind it, so the frame is never empty. The
           neighbours are asked for at the same time, so the arrows do not
           wait on the network either. */
        function prime(target) {
          var count = zoomSlides.length;
          for (var offset = -1; offset <= 1; offset++) {
            var i = (target + offset + count) % count;
            var image = zoomSlides[i].querySelector('.product__zoom-image');
            var hero = slides[i] ? slides[i].querySelector('.product__image') : null;
            if (!image) continue;
            if (!image.complete && hero && hero.currentSrc) {
              image.style.backgroundImage = 'url("' + hero.currentSrc + '")';
              image.addEventListener('load', dropStandIn);
            }
            image.loading = 'eager';
          }
        }

        /* Every image arrives zoomed in on its centre. A centred pan is
           always inside the limits, so there is nothing to clamp. */
        function present(target) {
          var count = zoomSlides.length;
          target = (target + count) % count;
          for (var i = 0; i < count; i++) zoomSlides[i].hidden = i !== target;
          zoomIndex = target;
          zoomImage = zoomSlides[target].querySelector('.product__zoom-image');
          scale = zoomDesktop.matches ? ZOOM_SCALE_DESKTOP : ZOOM_SCALE;
          panX = 0;
          panY = 0;
          place();
          prime(target);
          if (zoomCount) zoomCount.textContent = (target + 1) + ' / ' + count;
        }

        function step(direction) {
          if (zoomSlides.length < 2) return;
          present(zoomIndex + direction);

          /* Arrives from the side it came from, but only a short way: the
             image fills the screen here, and a full travel is a lot. */
          var slide = zoomSlides[zoomIndex];
          if (!zoomMotion.matches && typeof slide.animate === 'function') {
            slide.animate([
              { opacity: 0, transform: 'translateX(' + direction * 48 + 'px)' },
              { opacity: 1, transform: 'none' }
            ], { duration: 300, easing: zoomEase });
          }

          /* The hero follows out of sight, so closing lands on this image. */
          show(zoomIndex, direction, true);
        }

        /* The hero's square, as a transform of the image here. The hero is
           a square crop and this image is whole, so it is scaled to cover
           the square and clipped to it. The clip is in the image's own
           pixels, before the scale. */
        function heroFit(hero) {
          return Math.max(hero.width / zoomImage.offsetWidth, hero.height / zoomImage.offsetHeight);
        }

        function heroFrame() {
          var hero = media.getBoundingClientRect();
          var box = zoomStage.getBoundingClientRect();
          var width = zoomImage.offsetWidth;
          var height = zoomImage.offsetHeight;
          var fit = heroFit(hero);
          var x = hero.left + hero.width / 2 - (box.left + box.width / 2);
          var y = hero.top + hero.height / 2 - (box.top + box.height / 2);

          return {
            transform: 'translate(' + x + 'px, ' + y + 'px) scale(' + fit + ')',
            clipPath: 'inset(' + (height - hero.height / fit) / 2 + 'px ' + (width - hero.width / fit) / 2 + 'px)'
          };
        }

        /* The image lifts off the page and grows straight into the zoomed
           view, around the spot that was clicked. That spot stays under the
           cursor or the finger the whole way, so the visitor lands looking
           at what they pointed at. From the keyboard there is no spot
           (`detail` is 0), and it opens on the centre like any other. */
        function openZoom(event) {
          if (zoom.open) return;
          zoomClosing = false;
          zoom.removeAttribute('data-closing');
          present(index);

          if (typeof zoom.showModal === 'function') {
            zoom.showModal();
          } else {
            zoom.setAttribute('open', '');
          }
          zoomOpen.setAttribute('aria-expanded', 'true');

          if (event && event.detail > 0) {
            var hero = media.getBoundingClientRect();
            var fit = heroFit(hero);
            var spot = fromCentre(event.clientX, event.clientY);

            /* The spot on the image, from its centre in fitted pixels: the
               hero shows the image at `fit` times that size. */
            var x = (event.clientX - hero.left - hero.width / 2) / fit;
            var y = (event.clientY - hero.top - hero.height / 2) / fit;
            panX = spot.x - x * scale;
            panY = spot.y - y * scale;
            clamp();
            place();
          }

          if (zoomMotion.matches || typeof zoomImage.animate !== 'function') return;
          zoomImage.animate([
            heroFrame(),
            { transform: zoomImage.style.transform, clipPath: 'inset(0px 0px)' }
          ], { duration: 350, easing: zoomEase });
        }

        function finishZoom() {
          zoom.removeAttribute('data-closing');
          zoomClosing = false;
          if (typeof zoomImage.getAnimations === 'function') {
            zoomImage.getAnimations().forEach(function (animation) { animation.cancel(); });
          }
          if (typeof zoom.close === 'function') {
            zoom.close();
          } else {
            zoom.removeAttribute('open');
          }
          reset();
          zoomOpen.setAttribute('aria-expanded', 'false');
          zoomOpen.focus({ preventScroll: true });
        }

        /* And back down onto the hero, from wherever it is zoomed or
           panned to, as the scrim fades. The native close is immediate, so
           it waits for the landing; a timer covers the animation being
           dropped. */
        function closeZoom() {
          if (!zoom.open || zoomClosing) return;
          if (zoomMotion.matches || typeof zoomImage.animate !== 'function') {
            finishZoom();
            return;
          }

          zoomClosing = true;
          zoom.setAttribute('data-closing', '');

          var from = { transform: getComputedStyle(zoomImage).transform, clipPath: 'inset(0px 0px)' };
          var flight = zoomImage.animate([from, heroFrame()], {
            duration: 250,
            easing: zoomEase,
            fill: 'forwards'
          });

          var done = false;
          function end() {
            if (done) return;
            done = true;
            finishZoom();
          }

          flight.addEventListener('finish', end);
          timers.push(setTimeout(end, 400));
        }

        zoomOpen.addEventListener('click', openZoom);
        if (zoomClose) zoomClose.addEventListener('click', closeZoom);
        if (zoomPrev) zoomPrev.addEventListener('click', function () { step(-1); });
        if (zoomNext) zoomNext.addEventListener('click', function () { step(1); });

        /* Escape fires `cancel`; it is intercepted so the exit still animates. */
        zoom.addEventListener('cancel', function (event) {
          event.preventDefault();
          closeZoom();
        });

        zoom.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') step(-1);
          if (event.key === 'ArrowRight') step(1);
        });

        window.addEventListener('resize', function () {
          if (!zoom.open || !zoomImage) return;
          clamp();
          paint();
        });

        /* Every pointer on the stage, by id, measured from the centre. One
           drags the image about; two pinch it, scaling about the point
           between them. Mouse, touch and pen all come through here. */
        var pointers = {};
        var gesture = null;

        function points() {
          var all = [];
          for (var id in pointers) all.push(pointers[id]);
          return all;
        }

        function midpoint(all) {
          var x = 0;
          var y = 0;
          for (var i = 0; i < all.length; i++) {
            x += all[i].x;
            y += all[i].y;
          }
          return { x: x / all.length, y: y / all.length };
        }

        function spread(all) {
          return Math.hypot(all[0].x - all[1].x, all[0].y - all[1].y);
        }

        /* Taken afresh whenever a finger lands or lifts, so the image
           carries on from where it is rather than jumping. */
        function begin() {
          var all = points();
          var centre = midpoint(all);
          gesture = {
            x: centre.x,
            y: centre.y,
            panX: panX,
            panY: panY,
            scale: scale,
            spread: all.length > 1 ? Math.max(1, spread(all)) : 0,
            moved: gesture ? gesture.moved : false,
            pinched: (gesture ? gesture.pinched : false) || all.length > 1
          };
        }


        zoomStage.addEventListener('pointerdown', function (event) {
          if (zoomClosing) return;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          zoomStage.setPointerCapture(event.pointerId);
          pointers[event.pointerId] = fromCentre(event.clientX, event.clientY);
          begin();
          zoom.setAttribute('data-gesture', '');
        });

        zoomStage.addEventListener('pointermove', function (event) {
          if (!gesture || !pointers[event.pointerId]) return;
          pointers[event.pointerId] = fromCentre(event.clientX, event.clientY);

          var all = points();
          var centre = midpoint(all);
          var dx = centre.x - gesture.x;
          var dy = centre.y - gesture.y;

          /* A few pixels of slack, so a tap that wobbles is still a tap. */
          if (!gesture.moved && all.length < 2 && Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          gesture.moved = true;

          if (all.length > 1) {
            var next = Math.min(MAX_SCALE, Math.max(1, gesture.scale * spread(all) / gesture.spread));
            panX = centre.x - (gesture.x - gesture.panX) * (next / gesture.scale);
            panY = centre.y - (gesture.y - gesture.panY) * (next / gesture.scale);
            scale = next;
          } else if (scale > 1) {
            panX = gesture.panX + dx;
            panY = gesture.panY + dy;
            zoom.setAttribute('data-dragging', '');
          } else {
            /* At rest, a drag is a swipe, settled on release. */
            return;
          }

          clamp();
          paint();
        });

        function release(event) {
          if (!pointers[event.pointerId]) return;
          delete pointers[event.pointerId];

          /* A finger lifted mid-pinch: the other carries on dragging. */
          if (points().length) {
            begin();
            return;
          }

          var ended = gesture;
          gesture = null;
          zoom.removeAttribute('data-gesture');
          zoom.removeAttribute('data-dragging');
          if (!ended || event.type === 'pointercancel') return;

          var point = fromCentre(event.clientX, event.clientY);

          /* A single click or tap, with a mouse or a finger, zooms back out
             onto the page: the zoom closes, the image shrinking back into
             the hero. Two fingers set down and lifted without moving are
             not a tap. */
          if (!ended.moved) {
            if (!ended.pinched) closeZoom();
            return;
          }

          /* At rest, a sideways swipe changes image, as on the hero. */
          if (!ended.pinched && ended.scale === 1) {
            var dx = point.x - ended.x;
            var dy = point.y - ended.y;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
          }
        }

        zoomStage.addEventListener('pointerup', release);
        zoomStage.addEventListener('pointercancel', release);

        /* The wheel zooms about the cursor. A trackpad pinch arrives as a
           wheel with `ctrlKey` and much smaller steps, so it is sped up. */
        zoomStage.addEventListener('wheel', function (event) {
          event.preventDefault();
          if (zoomClosing) return;
          var delta = event.deltaY * (event.deltaMode === 1 ? 16 : 1);
          var speed = event.ctrlKey ? 0.01 : 0.002;
          zoomAt(scale * Math.exp(-delta * speed), fromCentre(event.clientX, event.clientY));
        }, { passive: false });
      }

      /* Size guide ----------------------------------------------------- */

      var guideToggle = root.querySelector('[data-size-guide]');
      var guide = root.querySelector('[data-size-guide-dialog]');

      if (guideToggle && guide) {
        var guidePanel = guide.querySelector('[data-size-guide-panel]');
        var guideClose = guide.querySelector('[data-size-guide-close]');
        var guideMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        var closing = false;

        function openGuide() {
          if (guide.open) return;
          closing = false;
          guide.removeAttribute('data-closing');
          if (typeof guide.showModal === 'function') {
            guide.showModal();
          } else {
            guide.setAttribute('open', '');
          }
          guideToggle.setAttribute('aria-expanded', 'true');
        }

        function finishClose() {
          guide.removeAttribute('data-closing');
          closing = false;
          if (typeof guide.close === 'function') {
            guide.close();
          } else {
            guide.removeAttribute('open');
          }
          guideToggle.setAttribute('aria-expanded', 'false');
          guideToggle.focus();
        }

        /* The native close is immediate, so the exit animation runs first
           and the dialog is only really closed once the panel has left.
           A timer covers the animation being dropped or disabled. */
        function closeGuide() {
          if (!guide.open || closing) return;
          if (guideMotion.matches || !guidePanel) {
            finishClose();
            return;
          }

          closing = true;
          guide.setAttribute('data-closing', '');

          var done = false;
          function end() {
            if (done) return;
            done = true;
            guidePanel.removeEventListener('animationend', end);
            finishClose();
          }

          guidePanel.addEventListener('animationend', end);
          timers.push(setTimeout(end, 300));
        }

        guideToggle.addEventListener('click', openGuide);
        if (guideClose) guideClose.addEventListener('click', closeGuide);

        /* Escape fires `cancel`; it is intercepted so the exit still animates. */
        guide.addEventListener('cancel', function (event) {
          event.preventDefault();
          closeGuide();
        });

        /* A click on the scrim, which is the dialog itself, closes. Clicks
           inside the panel bubble up with the panel as their target. */
        guide.addEventListener('click', function (event) {
          if (event.target === guide) closeGuide();
        });
      }

      /* Options and variants ------------------------------------------- */

      var variants = parseJSON(root.querySelector('[data-variant-data]'), []);
      var rows = root.querySelectorAll('[data-option]');
      var priceEl = root.querySelector('[data-price]');
      var variantInput = root.querySelector('[data-variant-id]');
      var addButton = root.querySelector('[data-add]');
      var addLabel = root.querySelector('[data-add-label]');
      var shippingNote = root.querySelector('[data-shipping-note]');
      var lastRow = parseInt(root.getAttribute('data-last-option'), 10);
      var selected = [];
      var quantities = {};

      /* Cart lines arrive as a list so repeated variants add up correctly. */
      parseJSON(root.querySelector('[data-cart-lines]'), []).forEach(function (line) {
        quantities[line.id] = (quantities[line.id] || 0) + line.quantity;
      });

      /* Rows no longer appear in option order (colour renders up top, the
         rest in the panel), so each is mapped to its option's index rather
         than trusting DOM order. */
      var rowIndexes = [];

      for (var r = 0; r < rows.length; r++) {
        var mapped = parseInt(rows[r].getAttribute('data-option-index'), 10);
        rowIndexes[r] = isNaN(mapped) ? r : mapped;
        var chosen = rows[r].querySelector('[aria-pressed="true"]');
        selected[rowIndexes[r]] = chosen ? chosen.getAttribute('data-value') : null;
      }

      function findVariant(options) {
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var match = true;
          for (var o = 0; o < options.length; o++) {
            if (variant.options[o] !== options[o]) { match = false; break; }
          }
          if (match) return variant;
        }
        return null;
      }

      /* Like findVariant, but rows without a choice match anything,
         preferring an available variant. A row can be left without a
         choice when every variant is sold out, and with exact matching
         every button would then count as unavailable. */
      function findCandidate(options) {
        var fallback = null;
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var match = true;
          for (var o = 0; o < options.length; o++) {
            if (options[o] === null) continue;
            if (variant.options[o] !== options[o]) { match = false; break; }
          }
          if (!match) continue;
          if (variant.available) return variant;
          if (!fallback) fallback = variant;
        }
        return fallback;
      }

      function quantityFor(variant) {
        return variant ? quantities[variant.id] || 0 : 0;
      }

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var firstRender = true;

      /* A count arriving is an element entering the screen, so it eases out.
         A count that merely changes gets a short pulse instead: with nothing
         else flashing, that pulse is the only signal confirming a repeat add. */
      function animateCount(badge, appearing) {
        if (reduceMotion.matches || typeof badge.animate !== 'function') return;

        var frames = appearing
          ? [{ opacity: 0, transform: 'scale(0.6)' }, { opacity: 1, transform: 'scale(1)' }]
          : [{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(1)' }];

        /* Only `transform` is animated. The badge is positioned with the
           separate `translate` property, which composes with this rather than
           being overwritten by it. */
        badge.animate(frames, {
          duration: appearing ? 200 : 260,
          easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        });
      }

      function setCount(badge, quantity) {
        var previous = badge.hidden ? 0 : parseInt(badge.textContent, 10) || 0;
        if (previous === quantity) return;

        badge.textContent = quantity;
        badge.hidden = quantity === 0;

        /* Nothing moves on load; motion only ever answers a change. */
        if (quantity === 0 || firstRender) return;
        animateCount(badge, previous === 0);
      }

      function update(changedMedia) {
        var current = findVariant(selected);

        for (var i = 0; i < rows.length; i++) {
          var optionIndex = rowIndexes[i];
          var buttons = rows[i].querySelectorAll('.product__value');

          for (var b = 0; b < buttons.length; b++) {
            var button = buttons[b];
            var value = button.getAttribute('data-value');
            button.setAttribute('aria-pressed', selected[optionIndex] === value ? 'true' : 'false');

            /* What this button would resolve to, holding the other rows. */
            var candidate = selected.slice();
            candidate[optionIndex] = value;
            var match = findCandidate(candidate);
            button.disabled = !match || !match.available;

            /* The count only ever belongs to an exact variant. */
            var badge = button.querySelector('[data-count]');
            if (badge && optionIndex === lastRow) setCount(badge, quantityFor(findVariant(candidate)));
          }
        }

        if (priceEl && current) priceEl.textContent = current.price;
        if (variantInput) variantInput.value = current ? current.id : '';

        if (addButton) {
          addButton.disabled = !current || !current.available;
          if (addLabel && current) {
            addLabel.textContent = !current.available
              ? root.getAttribute('data-soldout-text')
              : current.preorder
                ? root.getAttribute('data-preorder-text')
                : root.getAttribute('data-add-text');
          }
        }

        /* The ships-from line answers the pre-order, not the product, so
           it stands only while the selected variant is one. It is absent
           entirely unless the date is set and still ahead. */
        if (shippingNote) shippingNote.hidden = !current || !current.preorder;

        /* Changing colour should show that colour. */
        if (changedMedia && current) showMedia(current.mediaId);
      }

      for (var row = 0; row < rows.length; row++) {
        (function (rowIndex) {
          rows[rowIndex].addEventListener('click', function (event) {
            var button = event.target.closest('.product__value');
            if (!button || button.disabled) return;
            selected[rowIndexes[rowIndex]] = button.getAttribute('data-value');
            update(true);
          });
        })(row);
      }

      if (rows.length) update(false);
      firstRender = false;

      /* Scrolling the values ------------------------------------------- */

      /* A chevron appears at an end only while there is something past it,
         so a row of four or fewer never shows one. The position is read
         back from the track rather than counted, because what fits is a
         question of pixels: a resize, or a language with wider labels,
         changes the answer. */
      function setupScroller(option) {
        var track = option.querySelector('[data-values]');
        var prev = option.querySelector('[data-values-prev]');
        var next = option.querySelector('[data-values-next]');
        if (!track || !prev || !next) return;

        /* One screenful, measured off the values themselves: the distance
           between two of them is the one number that stays true as the
           panel resizes. */
        function page() {
          var items = track.querySelectorAll('.product__value');
          if (items.length < 2) return track.clientWidth;
          return (items[1].offsetLeft - items[0].offsetLeft) * 4;
        }

        function scrollBy(amount) {
          track.scrollBy({
            left: amount,
            behavior: reduceMotion.matches ? 'auto' : 'smooth'
          });
        }

        function sync() {
          /* A pixel of slack: the values divide the track into quarters,
             so neither end tends to land on a whole number. */
          var end = track.scrollWidth - track.clientWidth;
          prev.hidden = track.scrollLeft <= 1;
          next.hidden = track.scrollLeft >= end - 1;
        }

        prev.addEventListener('click', function () { scrollBy(-page()); });
        next.addEventListener('click', function () { scrollBy(page()); });
        track.addEventListener('scroll', sync);

        if (typeof ResizeObserver === 'function') {
          new ResizeObserver(sync).observe(track);
        }

        /* The page can open on a value past the fourth, named in the URL
           or simply the first one in stock. It belongs on screen, and set
           outright rather than scrolled to: nothing should be travelling
           before the visitor has looked at the page. */
        var pressed = track.querySelector('[aria-pressed="true"]');
        if (pressed) {
          var centred = pressed.offsetLeft - (track.clientWidth - pressed.offsetWidth) / 2;
          track.scrollLeft = centred > 0 ? centred : 0;
        }

        sync();
      }

      for (var sc = 0; sc < rows.length; sc++) setupScroller(rows[sc]);

      /* Cart ----------------------------------------------------------- */

      var form = root.querySelector('.product__form');
      var status = root.querySelector('[data-cart-status]');
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      var pending = false;
      var timers = [];

      /* With options the count badge reports the addition, so nothing else
         needs to flash. Without options there is no badge, and the button
         acknowledges the click instead. */
      function flash() {
        if (status) status.textContent = root.getAttribute('data-added-text') || '';

        var target = rows.length ? null : addButton;
        if (target) target.setAttribute('data-added', '');

        timers.push(setTimeout(function () {
          if (target) target.removeAttribute('data-added');
          if (status) status.textContent = '';
        }, 1600));
      }

      /* Rebuilds the counts and the header total from a cart object. */
      function applyCart(cart) {
        quantities = {};
        (cart.items || []).forEach(function (item) {
          quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
        });

        var counters = document.querySelectorAll('[data-cart-count]');
        for (var i = 0; i < counters.length; i++) {
          counters[i].textContent = cart.item_count;
          counters[i].hidden = cart.item_count === 0;
        }

        if (rows.length) update(false);
      }

      /* Fetches the real cart after an add, then tells the cart drawer so
         it can re-render itself. */
      function refreshCart() {
        return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            applyCart(cart);
            if (typeof CustomEvent === 'function') {
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: cart, source: 'product' }
              }));
            }
          })
          .catch(function () {
            /* The counts are cosmetic; the item is in the cart either way. */
          });
      }

      /* The cart drawer changed a quantity; the per-variant counts follow. */
      document.addEventListener('cart:updated', function (event) {
        var detail = event.detail || {};
        if (detail.source === 'product' || !detail.cart) return;
        applyCart(detail.cart);
      });

      /* Acknowledges the press instantly; the count badge only moves once
         the cart has actually answered, which can take a while. */
      function setLoading(on) {
        if (!addButton) return;
        if (on) {
          addButton.setAttribute('data-loading', '');
          addButton.setAttribute('aria-busy', 'true');
        } else {
          addButton.removeAttribute('data-loading');
          addButton.removeAttribute('aria-busy');
        }
      }

      function addToCart() {
        if (pending || !variantInput || !variantInput.value) return;
        pending = true;
        setLoading(true);
        if (status) status.textContent = root.getAttribute('data-adding-text') || '';

        var body = new URLSearchParams();
        body.set('id', variantInput.value);
        body.set('quantity', '1');

        fetch(form.action + '.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          body: body.toString()
        })
          .then(function (response) {
            if (!response.ok) throw new Error('add-to-cart failed');
            return response.json();
          })
          .then(function () {
            pending = false;
            return refreshCart();
          })
          .then(function () {
            /* The spinner hands over to the badge in the same frame the
               refreshed counts paint, so there is no gap where the press
               appears to have been forgotten. */
            setLoading(false);
            flash();
          })
          .catch(function () {
            pending = false;
            setLoading(false);
            if (status) status.textContent = root.getAttribute('data-error-text') || '';
          });
      }

      /* Without fetch the form posts normally and the visitor lands on the
         cart page, which is the standard no-JS behaviour. */
      if (form && addButton && window.fetch && window.URLSearchParams) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          addToCart();
        });
      }

      window.addEventListener('pagehide', function () {
        for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
      });
    }

    function init() {
      var roots = document.querySelectorAll('.product');
      for (var i = 0; i < roots.length; i++) setup(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    /* The theme editor re-renders sections in place. */
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
